import { render, staticRenderFns } from "./ModuleEnabled.vue?vue&type=template&id=08449ca6&"
import script from "./ModuleEnabled.vue?vue&type=script&lang=ts&"
export * from "./ModuleEnabled.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports